import { AfterViewInit, Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { SpinnerService } from './services/loader.service';
import { UserService } from './services/user.service';
import { Router } from '@angular/router';
import { NativeAPIService } from './services/native-api.service';
declare var navigator;
declare var window;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewInit {
  title = 'BCL-NPS';
lastTimeBackPress=0;
timePeriodToExit=2000;
  constructor(
    private router: Router,
    private service: UserService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private nativeapi: NativeAPIService) {
      nativeapi.onBackPress().subscribe(e=>{
        if(new Date().getTime() - this.lastTimeBackPress < this.timePeriodToExit){
            navigator.app.exitApp();
        }else{
            window.plugins.toast.showWithOptions(
                {
                  message: "Press again to exit.",
                  duration: "short", // which is 2000 ms. "long" is 4000. Or specify the nr of ms yourself.
                  position: "bottom",
                  addPixelsY: -40  // added a negative value to move it up a bit (default 0)
                }
              );
            this.lastTimeBackPress=new Date().getTime();
        }
      });
    //Event for closing Feedback popup on outside click
    let evt = (e) => {
      // debugger;
      let el = document.querySelector('app-feedback') as HTMLElement;
      let el2 = document.querySelector('#left-pannel') as HTMLElement;
      let hamMenuIcon = document.querySelector('img.menu-i') as HTMLElement;
      let profileMenus = document.querySelectorAll("#profile-menu,.user-name");

      if (!(el && el.contains(e.target as Node)))
        service.closeFeedbackOnOutSideClickSubject.next(true);
      if (!(el2 && el2.contains(e.target as Node)) && e.target != hamMenuIcon) {
        service.closeMobileMenuOutSideClickSubject.next(true);
      }
      profileMenus.forEach(_el => {

        let holder = document.querySelector(window.screen.width > 767 ? "#profile-menu img" : "li.user-name")

        if (!(_el && _el.contains(e.target as Node))&& !(holder && holder.contains(e.target as Node))) {
            service.closeProfileMenuOutSideClickSubject.next(true);
        }
      })

    }
    ['click'].map(e => window.addEventListener(e, evt, false));

  }
  ngAfterViewInit(): void {
    this.spinnerService.init('universal_loader');
    if(window["cordova"]){
      this.router.navigateByUrl("/login");
    }
  }

}
